module.exports = __webpack_public_path__ + "img/arrow-down-green.0d091c9d.svg";